import Loader from './Loader';

import './index.css';

export default Loader;
